import { render, staticRenderFns } from "./page-faq.vue?vue&type=template&id=b1ac29ce&scoped=true&"
import script from "./page-faq.vue?vue&type=script&lang=js&"
export * from "./page-faq.vue?vue&type=script&lang=js&"
import style0 from "./page-faq.vue?vue&type=style&index=0&id=b1ac29ce&prod&rel=stylesheet%2Fscss&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/_vue-loader@15.10.2@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b1ac29ce",
  null
  
)

export default component.exports